var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-payment"},[_c('div',{staticClass:"card-icon",style:({ backgroundColor: _vm.color })},[_c('ui-bill-icon')],1),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }